'use client';
import { Banner } from '~/apis/mercari';

import { Typography } from '@bgzt/ui';
import { LogImpression, Section, Spacing } from '~/components';

import { ExhibitionItem } from '../ExhibitionItem';

import styles from './Exhibition.module.css';
import { CONTENT_TYPE, EVENT_ACTION, EVENT_TYPE, PAGE_ID, VIEW_ID } from '~/apis/log/constant';
import { goToFullWebviewOnApp } from '~/services/app-interface';

type Props = {
  banners?: Banner[];
  onClick?: (webUrl: string) => void;
};

export const Exhibition = ({ banners, onClick }: Props) => {
  if (!banners || banners?.length < 1) return null;

  return (
    <Section fullWidth>
      <h2 className={styles.title}>
        <Typography variant="L3" color="gray-900">
          이주의 기획전
        </Typography>
      </h2>
      <Spacing height={12} />
      <ul className={styles.list}>
        {banners.map((banner, index) => (
          <li key={banner.imageUrl} onClick={() => onClick?.(banner.webUrl)}>
            <LogImpression
              params={{
                event_type: EVENT_TYPE.EXPOSURE,
                event_action: EVENT_ACTION.EXPOSURE_BANNER,
                page_id: PAGE_ID.SEARCH,
                view_id: VIEW_ID.EXHIBITION_BANNER,
                content_type: CONTENT_TYPE.BANNER,
                content_position: index,
                url: goToFullWebviewOnApp({ url: banner.webUrl }).to,
              }}
            >
              <ExhibitionItem imageUrl={banner.imageUrl} />
            </LogImpression>
          </li>
        ))}
      </ul>
    </Section>
  );
};
